var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupScgSolitionsDalian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 322.75 27.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-6a6e77 {\n        fill: #6a6e77;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M137.81,27.03h-8.85c-4.25,0-7.7-3.46-7.7-7.7V7.51h4.35v11.82c0,1.85,1.5,3.35,3.35,3.35h4.49V7.51h4.35v19.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M200.99,27.07h-4.35v-11.82c0-1.85-1.5-3.35-3.35-3.35h-4.49v15.17h-4.35V7.55h8.85c4.25,0,7.7,3.46,7.7,7.7v11.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M171.68,27.23c-5.47,0-9.92-4.45-9.92-9.92s4.45-9.92,9.92-9.92,9.92,4.45,9.92,9.92-4.45,9.92-9.92,9.92ZM171.68,11.74c-3.07,0-5.57,2.5-5.57,5.57s2.5,5.57,5.57,5.57,5.57-2.5,5.57-5.57-2.5-5.57-5.57-5.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M100.33,27.23c-5.47,0-9.92-4.45-9.92-9.92s4.45-9.92,9.92-9.92,9.92,4.45,9.92,9.92-4.45,9.92-9.92,9.92ZM100.33,11.74c-3.07,0-5.57,2.5-5.57,5.57s2.5,5.57,5.57,5.57,5.57-2.5,5.57-5.57-2.5-5.57-5.57-5.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6a6e77",
    x: 113.03,
    width: 4.58,
    height: 27.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6a6e77",
    x: 154.44,
    y: 7.35,
    width: 4.58,
    height: 19.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6a6e77",
    cx: 156.71,
    cy: 3.01,
    r: 2.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M151.6,11.74v-4.35h-5.71V2.62h-4.35v17.51c0,3.8,3.1,6.9,6.9,6.9h3.17v-4.35h-3.17c-1.4,0-2.54-1.14-2.54-2.55v-8.39h5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M214.65,27.23h-9.74v-4.35h9.74c.8,0,1.45-.65,1.45-1.45,0-.9-.76-1.89-1.45-1.89h-4c-3.59,0-6.3-2.52-6.3-5.86s2.82-6.3,6.3-6.3h9.2v4.35h-9.2c-1.07,0-1.94.87-1.94,1.94,0,1.43,1.62,1.5,1.94,1.5h4c3.09,0,5.8,2.92,5.8,6.24s-2.6,5.8-5.8,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M80.3,27.04h-9.63v-4.35h9.63c1.71,0,3.52-.86,3.52-2.46,0-1.39-.94-2.62-2.29-2.98l-6.11-1.51c-3.1-.83-5.24-3.61-5.24-6.78,0-3.86,3.14-7.01,7.01-7.01h10.41v4.35h-10.41c-1.46,0-2.65,1.19-2.65,2.65,0,1.2.81,2.26,1.97,2.56l6.11,1.51c3.29.88,5.56,3.83,5.56,7.19,0,3.89-3.39,6.82-7.88,6.82Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M38.73,27.23h-6.54c-6.95,0-12.61-5.65-12.61-12.6s5.65-12.6,12.61-12.6h6.54v4.35h-6.54c-4.55,0-8.25,3.7-8.25,8.25s3.7,8.25,8.25,8.25h6.54v4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M59.63,27.23h-7.14c-6.95,0-12.6-5.65-12.6-12.6s5.65-12.6,12.6-12.6h7.23v4.35h-7.23c-4.55,0-8.25,3.7-8.25,8.25s3.7,8.25,8.25,8.25h2.78v-8.34h4.35v12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M10.11,27.16H.48v-4.35h9.63c1.71,0,3.52-.86,3.52-2.46,0-1.39-.94-2.62-2.29-2.98l-6.11-1.51c-3.1-.83-5.24-3.61-5.24-6.78C0,5.21,3.14,2.07,7.01,2.07h10.41v4.35H7.01c-1.46,0-2.65,1.19-2.65,2.65,0,1.2.81,2.26,1.97,2.56l6.11,1.51c3.29.88,5.56,3.83,5.56,7.19,0,3.89-3.39,6.82-7.88,6.82Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6a6e77",
    x: 272.31,
    y: 0.16,
    width: 4.58,
    height: 27.07
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6a6e77",
    x: 279.22,
    y: 7.5,
    width: 4.58,
    height: 19.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6a6e77",
    cx: 281.49,
    cy: 3.17,
    r: 2.52
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M230.92,27.23h6.69c6.43,0,11.66-5.23,11.66-11.66s-5.23-11.66-11.66-11.66h-6.69v23.33ZM237.61,23.2h-2.58V7.93h2.58c4.21,0,7.63,3.42,7.63,7.63s-3.42,7.63-7.63,7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M322.75,27.23h-4.03v-10.94c0-1.71-1.39-3.1-3.1-3.1h-4.16v14.04h-4.03V9.16h8.19c3.93,0,7.13,3.2,7.13,7.13v10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M304.43,18.22v9.01h-9.12c-5,0-9.06-4.07-9.06-9.06,0-5,4.07-9.06,9.06-9.06,5.03,0,9.12,4.09,9.12,9.12ZM300.4,23.2v-4.98c0-2.81-2.28-5.09-5.09-5.09s-5.03,2.26-5.03,5.03,2.26,5.03,5.03,5.03h5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6a6e77",
    d: "M269.41,18.22v9.01h-9.12c-5,0-9.06-4.07-9.06-9.06s4.07-9.06,9.06-9.06c5.03,0,9.12,4.09,9.12,9.12ZM265.38,23.2v-4.98c0-2.81-2.28-5.09-5.09-5.09s-5.03,2.26-5.03,5.03c0,2.78,2.26,5.03,5.03,5.03h5.09Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupScgSolitionsDalian);
export default __webpack_public_path__ + "static/media/group_SCG_Solitions_Dalian.33b95543213ef67f5347767b172f1bf2.svg";
export { ForwardRef as ReactComponent };